"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./getEnvironmentFromHostname.cjs");function t(){return e.getEnvironmentFromHostname()==="test"}exports.isTestEnvironment=t;
//# sourceMappingURL=isTestEnvironment.cjs.map
